import React, { useState } from "react";
import querystring from "@/utils/querystring";
import img1 from "@/assets/img/financial-license/hkpz.png";
import img2 from "@/assets/img/financial-license/usa-msb.png";
import img3 from "@/assets/img/financial-license/ca-msb.png";
import "./stock.scss";

export default function () {
  const lang = querystring(window.location.hash, "lang");
  return (
    <div className="stock-business">
      <span className="placeholder">
        <img src={img1} alt="" />
      </span>
      <span className="title-content">
        {window.intl.get("股票 1、4、9号金融牌照")}
      </span>
      <span className="placeholder">
        <img src={img2} alt="" />
      </span>
      <span className="title-content">{window.intl.get("美国MSB牌照")}</span>
      <span className="placeholder">
        <img src={img3} alt="" />
      </span>
      <span className="title-content">{window.intl.get("加拿大MSB牌照")}</span>
    </div>
  );
}
